import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgDateRangeFilled = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.61 3c.625 0 1.13.503 1.13 1.125V5.25h4.52V4.125c0-.622.505-1.125 1.13-1.125s1.13.503 1.13 1.125V5.25h1.694c.936 0 1.695.756 1.695 1.688v1.687H4.091V6.938c0-.932.759-1.688 1.695-1.688H7.48V4.125C7.48 3.503 7.985 3 8.61 3M4.09 9.75H19.91v9.563c0 .931-.76 1.687-1.695 1.687H5.786a1.69 1.69 0 0 1-1.695-1.687zM6.917 12a.565.565 0 0 0-.565.563v2.25c0 .309.254.562.564.562h10.17c.31 0 .564-.253.564-.562v-2.25a.565.565 0 0 0-.565-.563z"
    }));
export default SvgDateRangeFilled;
